var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"collection-items"}},[_vm._l((_vm.items),function(item){return [_c('AppCollectionItem',{key:item.id,attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }